import { axios_instance } from "@/api/api";
import { downloadFileFromUrl } from "@/composables/useDownload";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import type { action } from ".";

export const use_file_download = defineStore("file_download", () => {
  const action = ref<action>();
  const is_watching = ref<boolean>(false);
  const user_canceled = ref<boolean>(false);
  const get_action_detail = async (id: string): Promise<action | undefined> => {
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `/api/v1/view/action/${id}`,
    };

    try {
      const response = await axios_instance.request<{ data: action }>(config);
      return response.data.data;
    } catch (error) {
      toast.error(error);
    }
  };
  const watch_for_action = async (action_id: string) => {
    action.value = await get_action_detail(action_id);
    if (!action.value) {
      (document.getElementById("download_modal") as HTMLDialogElement).close();
      toast.error("Không tìm thấy định danh của tác vụ");
      is_watching.value = false;
      return;
    }
    if (
      action.value.status === "failed" ||
      action.value.status === "canceled"
    ) {
      toast.error(`Tải tệp tin thất bại. trạng thái: ${action.value.status}`);
      is_watching.value = false;
      (document.getElementById("download_modal") as HTMLDialogElement).close();
      return;
    }

    if (action.value.status === "complete") {
      is_watching.value = false;
      (document.getElementById("download_modal") as HTMLDialogElement).close();
      setTimeout(() => {
        if (!action.value?.path) {
          return;
        }

        toast.info("Bắt đầu tải xuống tệp...");
        downloadFileFromUrl(
          `/api/v1/view/explore/download/${action.value.id}`,
          action.value.path.split(/\\/g)[-1] ?? "",
        );
      }, 500);
      return;
    }
    is_watching.value = true;

    setTimeout(() => {
      if (!action.value) return;
      if (user_canceled.value) {
        is_watching.value = false;
        user_canceled.value = false;
        return;
      }

      if (action.value.id) {
        watch_for_action(action.value.id);
      }
    }, 1000);
  };

  const create_download_file_action = async (
    file_path: string,
  ): Promise<string | undefined> => {
    const data = JSON.stringify({
      agent_id: router.currentRoute.value.params.client_id,
      action: "agent_push",
      type: "explore",
      path: file_path,
    });

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "/api/v1/view/action",
      data: data,
    };

    try {
      const response = await axios_instance.request<{
        action_id: string;
        message: string;
        status: string;
      }>(config);
      watch_for_action(response.data.action_id);
      (
        document.getElementById("download_modal") as HTMLDialogElement
      ).showModal();

      return response.data.action_id;
    } catch (err) {
      toast.error(err);
    }
  };

  const cancel_download = async () => {
    user_canceled.value = true;
  };

  return {
    action,
    is_watching,
    user_canceled,
    watch_for_action,
    create_download_file_action,
    cancel_download,
  };
});
